// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2MVBT","row":"styles_row__1J0-3"};